module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/now-with-ai-badge-3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/now-with-ai-badge-3.png
// module id = UXQ7
// module chunks = 0